// extracted by mini-css-extract-plugin
export var adjacentSlide = "_nx-9";
export var arrowButtonContainer = "_nx-5";
export var arrowButtonIcon = "_nx-6";
export var carouselArrowButton = "_nx-2";
export var carouselElementContainer = "_nx-1";
export var currentSlide = "_nx-8";
export var left = "_nx-3";
export var otherSlide = "_nx-a";
export var productCarouselContainer = "_nx-0";
export var right = "_nx-4";
export var sliderOverflow = "_nx-7";